import globals from '../../common/globals';

export default {
  name: 'vx-product-category',
  components: {},
  props: {
    tabBody: {
      type: Array,
      required: true,
    },
    showMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globals,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/view-site-content/vx-product-category/vx-product-category.js